module.exports = __webpack_public_path__ + "media/cine-documental-y-storytelling_reel.8a9c44af.mp4";